export const graphqlResponseError = 'GraphqlErrorResponse';

export const graphqlNullDataError = 'GraphqlNullData';
